import { render, staticRenderFns } from "./InvestorsList.vue?vue&type=template&id=bfee9138&"
import script from "./InvestorsList.vue?vue&type=script&lang=js&"
export * from "./InvestorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports